import { createIconComponent } from '../../factory/create-icon-component';
export const UnpinnedIcon = createIconComponent(
  'UnpinnedIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 20V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99 15H17.01C17.557 15 18 14.557 18 14.01V14.01C18 13.69 17.846 13.39 17.585 13.204L14.5 11V8L17.055 6.297C17.333 6.111 17.5 5.799 17.5 5.465V5C17.5 4.448 17.052 4 16.5 4H7.5C6.948 4 6.5 4.448 6.5 5V5.465C6.5 5.799 6.667 6.112 6.945 6.297L9.5 8V11L6.415 13.204C6.154 13.39 6 13.69 6 14.01V14.01C6 14.557 6.443 15 6.99 15V15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
